/* ============================================================================
   ENGORI — Rabattcode-Feld im Warenkorb

   Shrines eigener Handler (handleDiscountForm in der externen main.js) übernimmt
   den Code nicht zuverlässig. Hier wird das Absenden abgefangen und stattdessen
   der Weg genommen, der nachweislich funktioniert:

       GET /discount/<CODE>     -> Shopify merkt den Code für diesen Warenkorb
       danach Warenkorb neu laden

   Getestet: 34,99 € -> 31,50 € mit ENGORI10.
   ========================================================================= */
(function () {
  'use strict';

  var LAEUFT = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function meldung(form, text, fehler) {
    var el = form.querySelector('.cart-discount-form__error');
    if (!el) return;
    el.textContent = text;
    el.style.display = text ? 'block' : 'none';
    el.style.color = fehler ? '' : 'var(--eng-ok, #1a8c4e)';
  }

  function drawerNeuLaden() {
    var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (drawer && typeof drawer.getSectionsToRender === 'function' && typeof drawer.renderContents === 'function') {
      var ids = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      return fetch(root() + 'cart.js?sections=' + encodeURIComponent(ids) +
                   '&sections_url=' + encodeURIComponent(window.location.pathname))
        .then(function (r) { return r.json(); })
        .then(function (state) { drawer.renderContents(state); });
    }
    window.location.reload();
    return Promise.resolve();
  }

  function absenden(e) {
    var form = e.target.closest ? e.target.closest('.cart-discount-form') : null;
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();
    if (LAEUFT) return;

    var feld = form.querySelector('input[name="cart-discount-field"], input[type="text"]');
    var code = feld ? (feld.value || '').trim() : '';
    if (!code) { meldung(form, 'Bitte einen Rabattcode eingeben.', true); return; }

    LAEUFT = true;
    var btn = form.querySelector('button[type="submit"]');
    var btnText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Prüfe …'; }
    meldung(form, '', false);

    fetch(root() + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function () { return fetch(root() + 'cart.js', { credentials: 'same-origin' }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* 25.09.2026 (OFFER-05): Erfolg nur, wenn der Code selbst als Rabatt
           im Korb steht. Vorher reichte `cart.total_discount > 0` — das ist
           auch dann über 0, wenn nur die automatische Aktion „2. Tasche
           geschenkt“ wirkt, und meldete so einen Code als angewendet, der
           nichts tat. Gelesen werden nur Felder, die in der Ajax-Cart-Doku
           stehen (shopify.dev/docs/api/ajax/reference/cart):
           cart_level_discount_applications[] und
           items[].line_level_discount_allocations[].discount_application,
           jeweils mit title und type. `discount_codes[].applicable` steht dort
           nicht und wird deshalb nicht benutzt. Korb- und Zeilenrabatte treten
           gleichzeitig auf, deshalb beide lesen. */
        var gross = code.toUpperCase();
        var anwendungen = (cart.cart_level_discount_applications || []).slice();
        (cart.items || []).forEach(function (posten) {
          (posten.line_level_discount_allocations || []).forEach(function (z) {
            if (z && z.discount_application) anwendungen.push(z.discount_application);
          });
        });

        var an = anwendungen.some(function (d) {
          return (d.title || '').toUpperCase() === gross;
        });

        if (an) {
          meldung(form, 'Rabatt "' + gross + '" wurde angewendet.', false);
          if (feld) feld.value = '';
          return drawerNeuLaden();
        }

        /* Wirkt ein anderer, nicht per Code eingelöster Rabatt, ist das die
           automatische Aktion. Bewusst über `type !== 'discount_code'` statt
           `type === 'automatic'`: am Live-Korb lieferte der Typ der Aktion
           nicht 'automatic' (agent-memory/theme.md). */
        var aktion = anwendungen.some(function (d) {
          return d.type !== 'discount_code';
        });
        meldung(form, aktion
          ? 'Der Code „' + gross + '“ gilt nicht zusammen mit „2. Tasche geschenkt“.'
          : 'Der Code „' + gross + '“ ist für diesen Warenkorb nicht gültig.', true);
      })
      .catch(function () {
        meldung(form, 'Das hat gerade nicht geklappt. Bitte noch einmal versuchen.', true);
      })
      .finally(function () {
        LAEUFT = false;
        if (btn) { btn.disabled = false; btn.textContent = btnText; }
      });
  }

  /* In der Capture-Phase, damit Shrines eigener onsubmit nicht zuerst greift */
  document.addEventListener('submit', absenden, true);
})();
